class UserInviteController {
    constructor(userService, $mdDialog, $mdToast) {
        let self = this;

        self.inviteUser = () => {
            $mdDialog.show({
                clickOutsideToClose: true,
                templateUrl: 'userInvitationDialog.tmpl.html',
                parent: angular.element(document.body),
                multiple: true,
                controller: function DialogController($scope, $mdDialog) {
                    $scope.mail = '';

                    $scope.inviteUser = () => {
                        if(!$scope.mailForm.$invalid) {
                            userService.sendInvitation($scope.mail).then(() => {
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent('Invitation was sent.')
                                        .position('top center')
                                        .action('Hide')
                                        .highlightAction(true)
                                        .hideDelay(4000)
                                        .toastClass('success-toast'));
                            });
                            $mdDialog.hide();
                        }
                    };
                    $scope.cancel = () => {
                        $mdDialog.cancel();
                    };
                }
            }).then(() => {
                self.onSuccess();
            });
        };
    };
}

UserInviteController.$inject = ['UserService', '$mdDialog', '$mdToast'];

export default UserInviteController;



// WEBPACK FOOTER //
// ./src/app/pages/user/list/invite/userInviteController.js